module.exports = __webpack_public_path__ + "img/perfect-day-media-grey.ce5c6f11.png";